<template>
  <div>
    <v-radio-group :value="true" row dense>
      <v-radio label="Sessions Before FAD" :value="true"></v-radio>
    </v-radio-group>
    <v-divider class="my-5"></v-divider>
    <sessions-before-fad></sessions-before-fad>
  </div>
</template>
<script>
import SessionsBeforeFad from "./sessions-before-fad.vue";
export default {
  components: { SessionsBeforeFad },
};
</script>